(function(){
  angular.module('edxComponents')
    .component('edxAssignFocusAssignmentIcon', {
      templateUrl: '/resources/components/assign-focus/assign-focus-assignment-icon.component.html',
      controller: [AssignFocusAssignmentIconController],
      controllerAs: 'vm',
      bindings: {
        assignmentType: '<edxAssignmentType'
      }
    });

  function AssignFocusAssignmentIconController() {
    var vm = this;

    vm.$onChanges = $onChanges;

    var typeToIcon = {
      GOAL: '/resources/images/activity-feed-assigned-lesson-ongoing.png',
      GOAL_PLAY_PRESUMED_PASSED: '/resources/images/activity-feed-assigned-lesson-ongoing.png'
    };

    var defaultIcon = '/resources/images/activity-feed-assigned-lesson.png';

    function $onChanges(changes) {
      if (changes.assignmentType) {
        _refreshIconSrc();
      }
    }

    function _refreshIconSrc() {
      vm.iconSrc = typeToIcon[vm.assignmentType] || defaultIcon;
    }
  }
})();
